const PreviewModalAction = {
    SUBMIT: "PreviewModalAction.Submit",

}
export default PreviewModalAction;